import cn from 'classnames';
import React, {useEffect, useRef} from 'react';
import '../VideoStream/VideoStream.scss';

export type VideoStreamMetadataProps = {
  width: number;
  height: number;
  clientWidth: number;
  clientHeight: number;
  duration: number;
};

type FileVideoStreamProps = {
  className?: string;
  localVideoUrl: string;
  onLoadedMetadata?: (args: VideoStreamMetadataProps) => void;
};

export const FileVideoStream = ({
  className,
  localVideoUrl,
  onLoadedMetadata = () => {},
}: FileVideoStreamProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && localVideoUrl) {
      videoRef.current.src = localVideoUrl;
    }
  }, [localVideoUrl]);

  const onLoadedMetadataLocal = (e: any) => {
    const video = videoRef.current;
    if (video) {
      onLoadedMetadata({
        width: video.videoWidth,
        height: video.videoHeight,
        clientWidth: video.clientWidth,
        clientHeight: video.clientHeight,
        duration: video.duration,
      });
    }
  };

  return (
    <div className={cn('video-stream', className)}>
      <div className="video-stream__body">
        <div className="video-stream__status" />
        <div className="video-stream__video-container">
          <video
            className="video-stream__remote"
            ref={videoRef}
            autoPlay
            loop
            // Safari blocks autoplay videos that are not muted by default
            muted
            playsInline
            onLoadedMetadata={onLoadedMetadataLocal}
          ></video>
        </div>
      </div>
    </div>
  );
};
